import type { SVGProps } from "react";

type SvgTineProps = { color?: string } & SVGProps<SVGSVGElement>;

const SvgTine = ({ color = "#00205b", ...props }: SvgTineProps) => (
   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" focusable="false" aria-hidden="true" {...props}>
      <path
         d="M0 116.944h17.274v43.684a28.5 28.5 0 0 1-.404 3.913h14.223a30 30 0 0 1-.403-3.913v-43.684h17.3V105.6H0Zm198.562 0V105.6h-42.87a30 30 0 0 1 .404 3.914v51.114a28.5 28.5 0 0 1-.404 3.913h42.87v-11.344H169.5v-12.74h22.104v-11.344H169.5v-12.165Zm-125.62 47.597H58.72a30 30 0 0 0 .404-3.913v-51.114a28.5 28.5 0 0 0-.404-3.914h14.223a30 30 0 0 0-.404 3.914v51.114a28.4 28.4 0 0 0 .404 3.913m68.292-58.94h-14.222a28.4 28.4 0 0 1 .403 3.854v35.135l-28.507-38.993H82.192l3.503 5.013a11.62 11.62 0 0 1 2.156 7.445v42.565a28.4 28.4 0 0 1-.403 3.913h14.222a30 30 0 0 1-.403-3.913V128.85l25.65 35.695h14.303a30 30 0 0 1-.403-3.913v-51.176a27 27 0 0 1 .403-3.855M52.28 57.237h94.005v14.645H52.28Zm0 21.969h94.005V88.3H52.28ZM33.796 41.232c4.122 0 5.255 3.202 4.687 7.233s-2.75 19.214-2.75 19.214l9.223 4.192V34.719a22.1 22.1 0 0 0-9.224-1.695 20.54 20.54 0 0 0-9.843 2.135l3.774 6.968a11 11 0 0 1 4.13-.895m126.29 7.251c-.57-4.034.568-7.232 4.686-7.232a11 11 0 0 1 4.13.895l3.774-6.969a20.54 20.54 0 0 0-9.84-2.134 22.1 22.1 0 0 0-9.224 1.694v37.167l9.224-4.189s-2.182-15.183-2.75-19.214m-60.8-15.777c7.914 0 12.546 4.628 12.946 8.094H86.336c.4-3.466 5.032-8.094 12.947-8.094m19.775 1.368a44.4 44.4 0 0 0-6.32-3.279 42.5 42.5 0 0 1-5.622-4.287c-.733-.48-1.969-1.526-7.833-1.526-5.865 0-7.086 1.045-7.834 1.526a42.5 42.5 0 0 1-5.622 4.287 44.5 44.5 0 0 0-6.32 3.279c-.733.704-1.433 2.534-1.466 6.726H52.298v9.095h93.987v-9.095h-25.738c-.052-4.192-.734-6.022-1.467-6.726"
         style={{
            fill: color,
            strokeWidth: 3.66749
         }}
      />
      <text
         x={179.703}
         y={43.385}
         fill={color}
         fontFamily="Telefon-Normal, Telefon"
         fontSize={22.005}
         style={{
            strokeWidth: 3.66749
         }}
      >
         <tspan
            x={179.703}
            y={43.385}
            style={{
               strokeWidth: 3.66749
            }}
         >
            {"\xAE"}
         </tspan>
      </text>
   </svg>
);
export default SvgTine;
